import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import toast from "react-hot-toast";
import InputError from "../../../Components/InputError/InputError";
import { dateFormat, getBranchId, getType, toastStyle } from "../../../Helpers/Utils/Common";
import ApproveModal from "../../../Components/Modals/ApproveModal";
import { getAllBranches } from "../../../Helpers/apiCalls/branchApi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import upload from "../../../Assets/Images/upload.png";
import Upload from "antd/es/upload/Upload";
import FileExceedModal from "../../../Components/Modals/FileExceedModal";
import Modal from "antd/es/modal/Modal";
import trash from "../../../Assets/Images/trash.png";
import Select from "react-select";
import { validateAttendance, validateAttendanceUpload, validateTimeSheet } from "../../../Helpers/Validation/Employees/AttendanceValidation";
import { createAttendance, createMultipleAttendance, updateAttendance } from "../../../Helpers/apiCalls/Employees/AttendanceApi";
import * as XLSX from "xlsx";
import { getAttendance } from "../../../Helpers/apiCalls/Reports/DailyAttendanceApi";
import { createStoreDeposit, getZReading } from "../../../Helpers/apiCalls/Reports/StoreDepositApi";
import Compressor from "compressorjs";
import { searchBank } from "../../../Helpers/apiCalls/Manage/Banks";
import { validateStoreDeposit } from "../../../Helpers/Validation/StoreDeposit/StoreDepositValidation";
import Footer from "../../../Components/Footer/Footer";
/*
    -- VIEW BUILT ITEM
*/
export default function StoreDepositForm({add, edit}) {
    const { Dragger } = Upload;
    const { type, id } = useParams();
    let navigate = useNavigate();
    const accountType = getType();
    // const [isClicked, setIsClicked] = useState(false);
    const [items, setItems] = useState([]);
    const [zReading, setZReading] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [prevAttachments, setPrevAttachments] = useState([]);
    const [showFileExceedModal, setShowFileExceedModal] = useState(false);
    const [preview, setPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState("");
    // BUILT ITEM INFO VARIABLES
    const [employees, setEmployees] = useState([]);
    const [banks, setBanks] = useState([]);
    const [addDetails, setAddDetails] = useState({
        branch_id: "",
        deposited_by: "",
        datetime: "",
        overtime: "",
        time_sheet: [{actual_timein: "", actual_timeout: ""}],
    });
    const [branchId, setBranchId] = useState("")
    const [itemError, setItemError] = useState({})

    // Error Handling
    const [isError, setIsError] = useState({
        branch_from: false,
        qty: false,
        ingredients: false,
    });

    const [inactive, setInactive] = useState(true);

    async function fetchAttendance() {
        setAddDetails([]);
        const response = await getAttendance(id);

        if (response.data) {
            var data = response.data.data[0]
            data.time_sheet = data.attendance_entries.map((time) => {
                var info = time
                info.actual_timein = time?.actual_timein?.split(" ")[1]
                info.actual_timeout = time?.actual_timeout?.split(" ")[1]
                return info
            })
            setAddDetails(data);
            setPrevAttachments(response.data.data[0].attachments)
        }
    }

    // ATTENDANCE CHANGE HANDLER
    function handleTimeSheetChange(e, id) {
        const { name, value} = e.target;
        var newAddData = {...addDetails};
        var time_sheet = addDetails.time_sheet
        time_sheet[id][name] = value+":00";
        newAddData.time_sheet = time_sheet
        setAddDetails(newAddData);
    }

    const handleAddDetailsChange = (e) => {
        if (typeof e === "string") {
            setAddDetails((prevState) => ({
                ...prevState,
                ["item"]: e,
            }));
        } else if (e.target.name === "branch_from") {
            const { name, value } = e.target;
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        } else if (e.target.name === "build_item_id"){
            const { name, value } = e.target;
            const unit = getUnits(value);
            
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
                "unitList": unit[0],
                "build_item_unit": unit[0].item_units[0].unit_to,
                "build_item_unit_id": unit[0].item_units[0].id
            }));

        } else {
            const { name, value } = e.target;
            
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    function getUnits(id) {
        return items.filter((item) => item.id === id);
    }

    // SELECT DROPSEARCH CHANGE HANDLER
    function handleSelectChange(e) {
        const newList = {...addDetails};
        newList[e.name] = e.value;
        newList[e.select_value] = {
            label: e.label,
            value: e.value,
            name: e.name

        }
        setAddDetails(newList);
    }


    async function fetchZReading() {
        setZReading([]);
        const response = await getZReading({is_deposited: 0, branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : ""});
        if (response.data) {
            var sortedBranches = response.data.data.sort((a, b) =>
                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
            );
            let branches = sortedBranches.map((a) => {
                return {
                value: a.id,
                label: a.branch_name + " (" + dateFormat(a.added_on) + ")",
                name: "zcounter_id",
                select_value: "zcounter_id_value"
                };
            });
            setZReading(branches);
        }
    }

    async function fetchEmployees() {
        setEmployees([]);
        const response = await getAllEmployees();
        if(response.data) {
            var data = response.data.data.map((data) => {
                var info = data
                info.name = "deposited_by"
                info.select_value = "deposited_by_value"
                info.label = data.first_name + " " + data.last_name
                info.value = data.id
                return info
            })
            setEmployees(data);
        }
    }

    async function fetchBanks() {
        setBanks([]);
        const response = await searchBank("");
        if(response.data) {
            var data = response.data.data.data.map((data) => {
                var info = data
                info.name = "deposited_to"
                info.select_value = "deposited_to_value"
                info.label = data.bank_name
                info.value = data.id
                return info
            })
            setBanks(data);
        }
    }
    
    useEffect(() => {
        if(edit) {
            fetchAttendance();
        }
        fetchZReading();
        fetchEmployees()
        fetchBanks()
    }, []);


    const handleRemove = (selectedFile) => {
        var newlist = fileList.filter((file) => {
            return selectedFile.uid !== file.uid;
        });
        setFileList(newlist);
    };

    const handleBeforeUpload = (file) => {
        if (file.size > 2000000) {
            setShowFileExceedModal(true);
        } else {
            //COMPRESSING FILE
            new Compressor(file, {
                quality: 0.6,
                success: (compressedResult) => {
                    setFileList([...fileList, compressedResult]);
                },
            });
        }
        return false;
    };

    console.log(addDetails)

    function handleRemoveItemAttachment(url) {
        
        var newList = prevAttachments.filter((data) => {return data.file_url !== url})
        setPrevAttachments(newList);
        setPreview(false)
    }

    function handleSave() {
        if(add) {
            handleSaveAttendance()
        }
        //  else {
        //     handleUpdateAttendance()
        // }
    }

    async function handleSaveAttendance() {
        if (validateStoreDeposit(addDetails, setIsError)) {
            addDetails.attachments = fileList
            const response = await createStoreDeposit(addDetails);
            if (response.data) {
                toast.success(response.data.message, {style: toastStyle()});
                setTimeout(() => {
                    navigate("/storedeposit")
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
        } else {
            toast.error(
                "Please fill in all required fields",
                { style: toastStyle() }
            );
        }
    }

    // async function handleUpdateAttendance() {
    //     var errors = validateTimeSheet(addDetails.time_sheet)
    //     setItemError(errors)
    //     if (validateAttendance(addDetails, setIsError) && Object.keys(errors).length === 0) {
    //         addDetails.attachments = fileList
    //         addDetails.prev_files = prevAttachments
    //         const response = await updateAttendance(addDetails);
    //         if (response.data) {
    //             toast.success(response.data.message, {style: toastStyle()});
    //             setTimeout(() => {
    //                 navigate("/storedeposit")
    //             }, 1000);
    //         } else {
    //             response.error?.response?.data?.messages.map((data) => {
    //                 return toast.error(data);
    //             })
    //         }
    //     } else {
    //         toast.error(
    //             "Please fill in all required fields",
    //             { style: toastStyle() }
    //         );
    //     }
    // }

    
    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"DS REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-3">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ADD STORE DEPOSIT </h1>
                    </Col>
                </Row>


                
                <div className="mt-3 edit-form">
                    <Row className="nc-modal-custom-row ">
                        <Col sm={6}>
                            Date
                            <label className="badge-required">{` *`}</label>
                            <Form.Control
                                type="date"
                                name="date"
                                value={addDetails.date}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddDetailsChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.date}
                                message={"Date is required"}
                            />
                        </Col>
                        <Col sm={6}>
                            Z-Reading
                            <label className="badge-required">{` *`}</label>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Z-Reading..."
                                value={addDetails.zcounter_id_value}
                                options={zReading}
                                onChange={(e) => handleSelectChange(e)}
                            />
                            <InputError
                                isValid={isError.zcounter_id}
                                message={"Branch is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row ">
                        <Col sm={6}>
                            Deposited To
                            <label className="badge-required">{` *`}</label>
                            <Select 
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Bank..."
                                value={addDetails.deposited_to_value}
                                options={banks}
                                onChange={(e) => handleSelectChange(e)}
                            />
                            <InputError
                                isValid={isError.deposited_to}
                                message={"Bank is required"}
                            />
                        </Col>
                        <Col sm={6}>
                            Reference No.
                            <Form.Control
                                type="text"
                                name="reference_no"
                                value={addDetails.reference_no}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddDetailsChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row ">
                        <Col sm={6}>
                            Deposited On
                            <label className="badge-required">{` *`}</label>
                            <Form.Control
                                type="date"
                                name="deposited_on"
                                value={addDetails.deposited_on}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddDetailsChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.deposited_on}
                                message={"Deposited on is required"}
                            />
                        </Col>
                        <Col sm={6}>
                            Deposited By
                            <label className="badge-required">{` *`}</label>
                            <Select 
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Employee..."
                                value={addDetails.deposited_by_value}
                                options={employees}
                                onChange={(e) => handleSelectChange(e)}
                            />
                            <InputError
                                isValid={isError.deposited_by}
                                message={"Employee is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-4 mb-2">
                        <Col>
                            <Dragger
                                fileList={fileList}
                                onRemove={handleRemove}
                                beforeUpload={handleBeforeUpload}
                                multiple={false}
                                listType="picture"
                                progress={{ showInfo: true }}
                                // accept=".xlsx" // Accept only XLSX files
                            >
                                <img src={upload} className="cursor-pointer" />
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                            </Dragger>
                        </Col>
                    </Row>
                </div>
                <div className="d-flex justify-content-end pt-5 pb-3">
                    <button
                        type="button"
                        className="button-secondary me-3"
                        onClick={() => navigate("/storedeposit")}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="button-primary"
                        onClick={() => handleSave()}
                    >
                        Save
                    </button>
                </div>
            </div>
            <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
                <Row className="justify-content-center">
                    <img
                        alt="example"
                        style={{
                        width: '100%',
                        }}
                        src={previewFile}
                    />
                    <div className="mt-2 d-flex justify-content-center">
                        <img
                            src={trash}
                            alt="trash"
                            onClick={() => handleRemoveItemAttachment(previewFile)}
                            className="cursor-pointer"
                        />
                    </div>
                </Row>
            </Modal>
            <FileExceedModal
                show={showFileExceedModal}
                onHide={() => setShowFileExceedModal(false)}
                size="2MB"
            />
            <Footer/>
        </div>
    );
}
